import EventRegistryAPI from '../../../api/EventRegistryAPI';

export default {


  async eventImport({
    commit
  }, data) {
    return await new EventRegistryAPI().excelImport(data);
  },

  async getContractAssetComponentData({
    commit
  }, contractId) {
    const response = await new EventRegistryAPI().getContractAssetComponentData(contractId);
    commit("SET_CONTRACT_ASSET_COMPONENTS", response)
  }
};
